// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as PDPSelect$Showside from "./PDPSelect.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as UseQuantity$Showside from "../hook/UseQuantity.bs.js";
import * as PDPFormTypes$Showside from "./PDPFormTypes.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as PDPSelectTypes$Showside from "./PDPSelectTypes.bs.js";
import * as QuantityPicker$Showside from "./QuantityPicker.bs.js";
import * as PDPOptionButton$Showside from "./PDPOptionButton.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
var _HIDDEN_OPTIONS = ["Title", "mlveda_country"];
var _REQUIRED_OPTIONS = [/(^|\s|\()(size|length|dimension|width|height|fit|weight|area|thickness)(|s|es)($|\s|\))/i, /^Cut$/, /^Pyjama Option$/];
var _IMAGE_OPTIONS = ["Color", "Colour", "Style"];
var _DROPDOWN_OPTIONS = ["Grind"];
var _ALWAYS_SHOW_OPTIONS = ["Availability", "Fabric"];
function getFieldById(fields, id) {
  return Belt_Array.getBy(fields, function (f) {
    return Caml_obj.equal(f.id, id);
  });
}
function getFieldValue(field) {
  var match = field.value;
  if (match !== undefined) {
    return field.value;
  } else {
    return field.initialValue;
  }
}
function mergeFieldErrors(errors, field) {
  return {
    id: field.id,
    name: field.name,
    label: field.label,
    value: field.value,
    initialValue: field.initialValue,
    options: field.options,
    hidden: field.hidden,
    required: field.required,
    kind: field.kind,
    error: Belt_Option.map(Belt_Array.getBy(errors, function (error) {
      return Caml_obj.equal(error.fieldId, field.id);
    }), function (error) {
      return error.message;
    })
  };
}
function fieldToProductOption(field) {
  return Belt_Option.map(getFieldValue(field), function (value) {
    return {
      id: Curry._1(PDPFormTypes$Showside.FieldId.toString, field.id),
      name: field.name,
      value: value
    };
  });
}
function isFieldEmpty(field) {
  if (field.value === undefined) {
    return true;
  } else {
    return Caml_obj.equal(Belt_Option.map(field.value, function (prim) {
      return prim.trim();
    }), "");
  }
}
function willValidate(submitButtonType) {
  if (typeof submitButtonType === "number") {
    return submitButtonType === 0;
  } else {
    return Belt_Option.isSome(submitButtonType.confirmation);
  }
}
function getVariantByFields(product, fields) {
  return Belt_Array.get(Product$Showside.getVariantsByOptionNames(undefined, product, Belt_Array.keepMap(Belt_Array.map(fields, fieldToProductOption), function (a) {
    return a;
  })), 0);
}
function validate(form, field) {
  var noun = field.label.toLowerCase().replace(/(select|pick|choose)(\sa|\san|\s)/i, "");
  var modifier = /^[aeiou]/.test(noun) ? "an" : "a";
  if (isFieldEmpty(field) && field.required) {
    return {
      errorId: String(Js_math.random_int(10000, 99999)),
      formId: form.id,
      fieldId: field.id,
      fieldName: field.name,
      message: "Please select " + modifier + " " + noun + ""
    };
  }
}
function makeSubmission(validationOpt, form, submitButtonType, fields) {
  var validation = validationOpt !== undefined ? validationOpt : true;
  var errors = Belt_Array.keepMap(Belt_Array.map(fields, function (field) {
    if (validation) {
      return validate(form, field);
    }
  }), function (a) {
    return a;
  });
  var product = form.product;
  if (product === undefined) {
    return {
      TAG: /* Errors */1,
      _0: []
    };
  }
  var variant = Belt_Option.getWithDefault(getVariantByFields(product, fields), product.firstVariant);
  if (errors.length !== 0) {
    return {
      TAG: /* Errors */1,
      _0: errors
    };
  } else {
    return {
      TAG: /* AllGood */0,
      _0: {
        submitButtonType: submitButtonType,
        product: product,
        variant: variant,
        quantity: Belt_Option.getWithDefault(form.quantity, 1)
      }
    };
  }
}
function noopPromise1(param) {
  return Promise.resolve(undefined);
}
function noopPromise2(param) {
  return Promise.resolve([]);
}
function noop1(param) {}
var emptyForm_id = Curry._1(PDPFormTypes$Showside.FormId.fromString, "");
var emptyForm_fields = [];
function emptyForm_setQuantity(param) {}
var emptyForm_orderOfSelection = [];
var emptyForm = {
  id: emptyForm_id,
  fields: emptyForm_fields,
  product: undefined,
  variant: undefined,
  quantity: undefined,
  setQuantity: emptyForm_setQuantity,
  reset: noop1,
  orderOfSelection: emptyForm_orderOfSelection,
  onSubmit: noopPromise1,
  onChange: noopPromise2
};
function dynamicallyDisableAndHideOptions(hideOutOfStock, product, allFields, field) {
  var index = Belt_Option.getWithDefault(Belt_Array.getIndexBy(allFields, function (f) {
    return Caml_obj.equal(f.id, field.id);
  }), -1);
  var otherValues = Belt_Array.map(Belt_Array.keep(allFields, function (f) {
    return Caml_obj.notequal(f.id, field.id);
  }), fieldToProductOption);
  var updateOption = function (option) {
    var productOption_id = option.id;
    var productOption_name = option.groupName;
    var productOption_value = option.value;
    var productOption = {
      id: productOption_id,
      name: productOption_name,
      value: productOption_value
    };
    var lookUpOptions = Belt_Array.concat(Belt_Array.keepMap(otherValues, function (a) {
      return a;
    }), [productOption]);
    var variants = Product$Showside.getVariantsByOptionNames(true, product, lookUpOptions);
    var allPossibleVariants = Product$Showside.getVariantsByOptionNames(false, product, [productOption]);
    var inStockVariants = Belt_Array.keep(variants, function (param) {
      return param.availability !== /* OutOfStock */0;
    });
    var everyVariantIsOutOfStock = hideOutOfStock && Belt_Array.every(allPossibleVariants, function (variant) {
      return variant.availability === /* OutOfStock */0;
    });
    var disabled = inStockVariants.length === 0;
    var hidden = variants.length === 0 && index === 0 || everyVariantIsOutOfStock || field.hidden;
    return {
      id: option.id,
      groupName: option.groupName,
      label: option.label,
      value: option.value,
      alt: option.alt,
      swatch: option.swatch,
      disabled: disabled,
      hidden: hidden
    };
  };
  var nextOptions = Belt_Array.map(field.options, updateOption);
  return {
    id: field.id,
    name: field.name,
    label: field.label,
    value: field.value,
    initialValue: field.initialValue,
    options: nextOptions,
    hidden: field.hidden,
    required: field.required,
    kind: field.kind,
    error: field.error
  };
}
function dynamicallyChooseOptimalValue(hideOutOfStock, selfField, changedField, product, variant, allFields, orderOfSelection) {
  var optionNames = Belt_Array.keepMap(Belt_Array.map(allFields, fieldToProductOption), function (a) {
    return a;
  });
  var selectedVariant = Belt_Array.get(Product$Showside.getVariantsByOptionNames(true, product, optionNames), 0);
  var closestInStockVariant = Belt_Array.get(Belt_Array.keep(Belt_Option.mapWithDefault(changedField.value, [], function (value) {
    return Product$Showside.getVariantsByOptionValue(undefined, product, value);
  }), function (variant) {
    if (hideOutOfStock) {
      return variant.availability !== /* OutOfStock */0;
    } else {
      return true;
    }
  }), 0);
  var userSelection = getFieldById(orderOfSelection, selfField.id);
  var isSelectedOptionHidden = Belt_Option.mapWithDefault(Belt_Option.flatMap(selfField.value, function (value) {
    return Belt_Array.getBy(selfField.options, function (f) {
      return f.value === value;
    });
  }), true, function (option) {
    return option.hidden;
  }) && !selfField.hidden;
  var match = selfField.initialValue;
  var nextValue = isSelectedOptionHidden ? undefined : userSelection !== undefined || selectedVariant !== undefined || match === undefined ? selfField.value : Belt_Option.map(Belt_Option.flatMap(closestInStockVariant, function (v) {
    return Js_dict.get(v.options, selfField.name);
  }), function (o) {
    return o.value;
  });
  return {
    id: selfField.id,
    name: selfField.name,
    label: selfField.label,
    value: nextValue,
    initialValue: selfField.initialValue,
    options: selfField.options,
    hidden: selfField.hidden,
    required: selfField.required,
    kind: selfField.kind,
    error: selfField.error
  };
}
function applyOrderOfSelection(orderOfSelection, fields) {
  return Belt_Array.map(fields, function (field) {
    var value = Belt_Option.flatMap(Belt_Array.getBy(orderOfSelection, function (selectedField) {
      return Caml_obj.equal(selectedField.id, field.id);
    }), function (param) {
      return param.value;
    });
    var value$1 = value !== undefined ? value : field.initialValue;
    return {
      id: field.id,
      name: field.name,
      label: field.label,
      value: value$1,
      initialValue: field.initialValue,
      options: field.options,
      hidden: field.hidden,
      required: field.required,
      kind: field.kind,
      error: field.error
    };
  });
}
function makeFieldsFromProduct(hideOutOfStock, product, variant) {
  var isRequired = function (name) {
    return Belt_Array.some(_REQUIRED_OPTIONS, function (__x) {
      return __x.test(name);
    });
  };
  var isHidden = function (name) {
    return Belt_Array.some(_HIDDEN_OPTIONS, function (n) {
      return n === name;
    });
  };
  var isImageOption = function (name) {
    return Belt_Array.some(_IMAGE_OPTIONS, function (n) {
      return n === name;
    });
  };
  var isAlwaysShow = function (name) {
    return Belt_Array.some(_ALWAYS_SHOW_OPTIONS, function (n) {
      return n === name;
    });
  };
  var updateValue = function (field) {
    var isRequired$1 = isRequired(field.name);
    var isHidden$1 = isHidden(field.name);
    var visibleOptions = Belt_Array.keep(field.options, function (param) {
      return !param.hidden;
    });
    var selectedValue = Belt_Option.keep(Product$Showside.Variant.getOptionValue(variant, field.name), function (value) {
      return Belt_Array.some(visibleOptions, function (param) {
        return value === param.value;
      });
    });
    var firstValue = Belt_Option.map(Belt_Array.get(field.options, 0), function (option) {
      return option.value;
    });
    var value = selectedValue !== undefined ? selectedValue : firstValue !== undefined ? firstValue : undefined;
    var initialValue = !isRequired$1 || field.options.length === 1 || isHidden$1 ? value : undefined;
    return {
      id: field.id,
      name: field.name,
      label: field.label,
      value: value,
      initialValue: initialValue,
      options: field.options,
      hidden: field.hidden,
      required: field.required,
      kind: field.kind,
      error: field.error
    };
  };
  var fields = Belt_Array.map(Js_dict.entries(product.options), function (param) {
    var options = param[1];
    var optionName = param[0];
    var isRequired$1 = isRequired(optionName);
    var isImageOption$1 = isImageOption(optionName);
    var isHidden$1 = isHidden(optionName);
    var isAlwaysShow$1 = isAlwaysShow(optionName);
    var kind = isImageOption$1 ? /* SwatchButton */1 : /* Button */0;
    var id = Belt_Option.map(Belt_Array.get(options, 0), function (option) {
      return option.id;
    });
    var hidden = isHidden$1 || options.length === 0 || options.length === 1 && !isRequired$1 && !isAlwaysShow$1;
    return updateValue({
      id: Curry._1(PDPFormTypes$Showside.FieldId.fromString, Belt_Option.getWithDefault(id, optionName)),
      name: optionName,
      label: optionName,
      value: undefined,
      initialValue: undefined,
      options: Belt_Array.map(options, function (option) {
        var variant = Belt_Array.get(Product$Showside.getVariantsByOptionName(product, option.value), 0);
        var swatch = Belt_Option.map(Belt_Option.map(variant, function (param) {
          return Product$Showside.getDisplaySwatchImage(product, param);
        }), function (image) {
          return {
            TAG: /* ImageSwatch */0,
            _0: image
          };
        });
        var alt = Belt_Option.getWithDefault(Belt_Option.flatMap(variant, function (variant) {
          return variant.name;
        }), product.name);
        return PDPSelectTypes$Showside.makeOption(option.value, option.name, swatch, undefined, undefined, option.id, alt, option.value);
      }),
      hidden: hidden,
      required: isRequired$1,
      kind: kind,
      error: undefined
    });
  });
  return Belt_Array.map(Belt_Array.map(fields, function (param) {
    return dynamicallyDisableAndHideOptions(hideOutOfStock, product, fields, param);
  }), updateValue);
}
var empty_errors = [];
var empty = {
  product: undefined,
  form: emptyForm,
  pendingFields: undefined,
  errors: empty_errors,
  submittedCallback: noop1
};
function noopChange(param, param$1) {}
function noopSubmit(param) {
  return Promise.resolve(undefined);
}
var context = React.createContext(empty);
var provider = context.Provider;
function PDPForm$Wrapper$Provider(Props) {
  var product = Props.product;
  var form = Props.form;
  var pendingFields = Props.pendingFields;
  var errors = Props.errors;
  var submittedCallbackOpt = Props.submittedCallback;
  var children = Props.children;
  var submittedCallback = submittedCallbackOpt !== undefined ? submittedCallbackOpt : noop1;
  return React.createElement(provider, {
    value: {
      product: product,
      form: form,
      pendingFields: pendingFields,
      errors: errors,
      submittedCallback: submittedCallback
    },
    children: children
  });
}
PDPForm$Wrapper$Provider.displayName = "PDPForm.Wrapper.Provider";
var Provider = {
  provider: provider,
  make: PDPForm$Wrapper$Provider
};
function use(param) {
  return React.useContext(context);
}
function PDPForm$Wrapper(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var submittedCallbackOpt = Props.submittedCallback;
  var hideOutOfStock = Props.hideOutOfStock;
  var onChangeOpt = Props.onChange;
  var onSubmitOpt = Props.onSubmit;
  var children = Props.children;
  var submittedCallback = submittedCallbackOpt !== undefined ? submittedCallbackOpt : noop1;
  var onChange = onChangeOpt !== undefined ? onChangeOpt : noopChange;
  var onSubmit = onSubmitOpt !== undefined ? onSubmitOpt : noopSubmit;
  var id = React.useMemo(function () {
    return Curry._1(PDPFormTypes$Showside.FormId.fromString, String(Js_math.random_int(10000, 99999)));
  }, []);
  var match = React.useState(function () {
    return variant;
  });
  var setSelectedVariant = match[1];
  var match$1 = UseQuantity$Showside.useQuantity(1, product, variant);
  var match$2 = React.useState(function () {
    return makeFieldsFromProduct(hideOutOfStock, product, variant);
  });
  var setFields = match$2[1];
  var fields = match$2[0];
  var match$3 = React.useState(function () {
    return [];
  });
  var setErrors = match$3[1];
  var match$4 = React.useState(function () {
    return [];
  });
  var setOrderOfSelection = match$4[1];
  var orderOfSelection = match$4[0];
  var pendingFields = Belt_Array.map(Belt_Array.keep(applyOrderOfSelection(orderOfSelection, fields), isFieldEmpty), function (field) {
    return field.id;
  });
  var reset = function (param) {
    Curry._1(setFields, function (param) {
      return makeFieldsFromProduct(hideOutOfStock, product, variant);
    });
    Curry._1(setErrors, function (param) {
      return [];
    });
    Curry._1(setOrderOfSelection, function (param) {
      return [];
    });
    Curry._1(setSelectedVariant, function (param) {
      return variant;
    });
  };
  React.useEffect(function () {
    reset(undefined);
  }, [product.id]);
  React.useEffect(function () {
    Curry._1(setFields, function (param) {
      return makeFieldsFromProduct(hideOutOfStock, product, variant);
    });
  }, [variant.id]);
  var form_product = product;
  var form_variant = match[0];
  var form_quantity = match$1[0];
  var form_setQuantity = match$1[1];
  var form_onSubmit = function (param) {
    Curry._1(setErrors, function (previousErrors) {
      if (param.TAG === /* AllGood */0) {
        if (willValidate(param._0.submitButtonType)) {
          return [];
        } else {
          return previousErrors;
        }
      } else {
        return param._0;
      }
    });
    return Curry._1(onSubmit, param);
  };
  var form_onChange = function (param) {
    return new Promise(function (resolve, reject) {
      var newFields = Belt_Array.map(fields, function (field) {
        if (Caml_obj.equal(field.id, param.id)) {
          return param;
        } else {
          return field;
        }
      });
      var newFields$1 = Belt_Array.map(newFields, function (f) {
        if (Caml_obj.equal(f.id, param.id)) {
          return param;
        } else {
          return dynamicallyChooseOptimalValue(hideOutOfStock, dynamicallyDisableAndHideOptions(hideOutOfStock, product, newFields, f), param, product, variant, newFields, orderOfSelection);
        }
      });
      Curry._1(setErrors, function (errors) {
        return Belt_Array.keep(errors, function (error) {
          return Caml_obj.notequal(error.fieldId, param.id);
        });
      });
      Curry._1(setOrderOfSelection, function (previousOrder) {
        return Belt_Array.concat(Belt_Array.keep(Belt_Array.keep(newFields$1, function (f0) {
          return Belt_Array.some(previousOrder, function (f1) {
            return Caml_obj.equal(f1.id, f0.id);
          });
        }), function (field) {
          return Caml_obj.notequal(field.id, param.id);
        }), [param]);
      });
      Curry._1(setFields, function (param) {
        return newFields$1;
      });
      var nextVariant = getVariantByFields(product, newFields$1);
      Curry._1(setSelectedVariant, function (param) {
        return nextVariant;
      });
      Curry._2(onChange, product, nextVariant);
      resolve(newFields$1);
    });
  };
  var form = {
    id: id,
    fields: fields,
    product: form_product,
    variant: form_variant,
    quantity: form_quantity,
    setQuantity: form_setQuantity,
    reset: reset,
    orderOfSelection: orderOfSelection,
    onSubmit: form_onSubmit,
    onChange: form_onChange
  };
  return React.createElement(PDPForm$Wrapper$Provider, {
    product: product,
    form: form,
    pendingFields: pendingFields,
    errors: match$3[0],
    submittedCallback: submittedCallback,
    children: children
  });
}
PDPForm$Wrapper.displayName = "PDPForm.Wrapper";
var Wrapper = {
  empty: empty,
  noopChange: noopChange,
  noopSubmit: noopSubmit,
  context: context,
  Provider: Provider,
  use: use,
  make: PDPForm$Wrapper
};
function PDPForm$QuantityPicker(Props) {
  var optionSizeOpt = Props.optionSize;
  var onRender = Props.onRender;
  var optionSize = optionSizeOpt !== undefined ? optionSizeOpt : /* Md */2;
  var match = React.useContext(context);
  var form = match.form;
  var match$1 = form.quantity;
  if (match$1 !== undefined && onRender !== undefined) {
    return Curry._2(onRender, match$1, function (nextQty) {
      Curry._1(form.setQuantity, function (param) {
        return nextQty;
      });
    });
  }
  return React.createElement(QuantityPicker$Showside.make, {
    optionSize: optionSize,
    quantity: form.quantity,
    setQuantity: form.setQuantity
  });
}
PDPForm$QuantityPicker.displayName = "PDPForm.QuantityPicker";
var QuantityPicker = {
  make: PDPForm$QuantityPicker
};
function PDPForm$Field(Props) {
  var optionSize = Props.optionSize;
  var optionStyle = Props.optionStyle;
  var dropdownDirectionOpt = Props.dropdownDirection;
  var truncateAt = Props.truncateAt;
  var product = Props.product;
  var field = Props.field;
  var onChange = Props.onChange;
  var tabIndex = Props.tabIndex;
  var scrollIntoViewOnErrorOpt = Props.scrollIntoViewOnError;
  var dropdownDirection = dropdownDirectionOpt !== undefined ? dropdownDirectionOpt : [/* Right */1, /* Bottom */1];
  var scrollIntoViewOnError = scrollIntoViewOnErrorOpt !== undefined ? scrollIntoViewOnErrorOpt : true;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = field.value;
  var value = match$1 !== undefined ? field.value : field.initialValue;
  var options = field.options;
  var handleChange = function (newValue) {
    Curry.app(trackEvent, ["Clicked Product Variant", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    if (field.kind === /* SwatchButton */1) {
      Curry.app(trackEvent, ["product details:swatch", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    Curry._1(onChange, {
      id: field.id,
      name: field.name,
      label: field.label,
      value: newValue,
      initialValue: field.initialValue,
      options: field.options,
      hidden: field.hidden,
      required: field.required,
      kind: field.kind,
      error: field.error
    });
  };
  var scrollIntoViewOnError$1 = Belt_Option.isSome(field.error) && scrollIntoViewOnError;
  var match$2 = field.name;
  var dataTestId;
  switch (match$2) {
    case "Color":
      dataTestId = "pdp-color-button";
      break;
    case "Size":
      dataTestId = "pdp-size-button";
      break;
    case "Style":
      dataTestId = "pdp-style-button";
      break;
    default:
      dataTestId = undefined;
  }
  var match$3 = field.name;
  var errorDataTestId;
  switch (match$3) {
    case "Color":
      errorDataTestId = "pdp-color-error";
      break;
    case "Size":
      errorDataTestId = "pdp-size-error";
      break;
    case "Style":
      errorDataTestId = "pdp-style-error";
      break;
    default:
      errorDataTestId = undefined;
  }
  var tmp = {
    options: options,
    verticalDirection: dropdownDirection[1],
    horizontalDirection: dropdownDirection[0],
    kind: field.kind,
    scrollIntoViewOnError: scrollIntoViewOnError$1,
    onChange: handleChange
  };
  if (field.error !== undefined) {
    tmp.error = field.error;
  }
  if (optionSize !== undefined) {
    tmp.optionSize = Caml_option.valFromOption(optionSize);
  }
  if (optionStyle !== undefined) {
    tmp.optionStyle = Caml_option.valFromOption(optionStyle);
  }
  if (truncateAt !== undefined) {
    tmp.truncateAt = truncateAt;
  }
  if (value !== undefined) {
    tmp.value = value;
  }
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (errorDataTestId !== undefined) {
    tmp.errorDataTestId = Caml_option.valFromOption(errorDataTestId);
  }
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return React.createElement(PDPSelect$Showside.make, tmp);
}
PDPForm$Field.displayName = "PDPForm.Field";
var Field = {
  make: PDPForm$Field
};
function PDPForm$AllFields(Props) {
  var dropdownDirectionOpt = Props.dropdownDirection;
  var optionSize = Props.optionSize;
  var optionStyle = Props.optionStyle;
  var colorOptionSize = Props.colorOptionSize;
  var hideEmptyOptionsOpt = Props.hideEmptyOptions;
  var scrollIntoViewOnErrorOpt = Props.scrollIntoViewOnError;
  var truncateAt = Props.truncateAt;
  var onRenderOpt = Props.onRender;
  var tabIndex = Props.tabIndex;
  var dropdownDirection = dropdownDirectionOpt !== undefined ? dropdownDirectionOpt : [/* Right */1, /* Bottom */1];
  var hideEmptyOptions = hideEmptyOptionsOpt !== undefined ? hideEmptyOptionsOpt : false;
  var scrollIntoViewOnError = scrollIntoViewOnErrorOpt !== undefined ? scrollIntoViewOnErrorOpt : true;
  var onRender = onRenderOpt !== undefined ? onRenderOpt : function (param, param$1, e) {
    return e;
  };
  var match = React.useContext(context);
  var errors = match.errors;
  var form = match.form;
  var fields = Belt_Array.keep(Belt_Array.keep(form.fields, function (field) {
    if (hideEmptyOptions) {
      return field.options.length > 1;
    } else {
      return true;
    }
  }), function (field) {
    return !field.hidden;
  });
  var countMap = Belt_Array.map(fields, function (field) {
    return Belt_Array.keep(field.options, function (param) {
      return !param.hidden;
    }).length;
  });
  var handleChange = function (updated) {
    Curry._1(form.onChange, updated);
  };
  return Belt_Array.mapWithIndex(Belt_Array.map(Belt_Array.keep(fields, function (field) {
    return Belt_Array.some(field.options, function (o) {
      return !o.hidden;
    });
  }), function (param) {
    return mergeFieldErrors(errors, param);
  }), function (i, rawField) {
    var optionSize$1 = colorOptionSize !== undefined ? rawField.kind === /* SwatchButton */1 ? colorOptionSize : optionSize !== undefined ? optionSize : undefined : optionSize !== undefined ? optionSize : undefined;
    var countPreviousFields = Belt_Array.reduceWithIndex(countMap, 0, function (acc, curr, index) {
      return acc + (index < i ? curr : 0) | 0;
    });
    var isDropdown = Belt_Array.some(_DROPDOWN_OPTIONS, function (name) {
      return name === rawField.name;
    });
    var truncateAt$1 = isDropdown ? 0 : truncateAt !== undefined && truncateAt >= 1 ? Math.max(1, truncateAt - countPreviousFields | 0) : undefined;
    var computedValue = Belt_Option.flatMap(Belt_Array.getBy(form.orderOfSelection, function (order) {
      return Caml_obj.equal(order.id, rawField.id);
    }), function (param) {
      return param.value;
    });
    var fieldWithComputedValue_id = rawField.id;
    var fieldWithComputedValue_name = rawField.name;
    var fieldWithComputedValue_label = rawField.label;
    var fieldWithComputedValue_initialValue = rawField.initialValue;
    var fieldWithComputedValue_options = rawField.options;
    var fieldWithComputedValue_hidden = rawField.hidden;
    var fieldWithComputedValue_required = rawField.required;
    var fieldWithComputedValue_kind = rawField.kind;
    var fieldWithComputedValue_error = rawField.error;
    var fieldWithComputedValue = {
      id: fieldWithComputedValue_id,
      name: fieldWithComputedValue_name,
      label: fieldWithComputedValue_label,
      value: computedValue,
      initialValue: fieldWithComputedValue_initialValue,
      options: fieldWithComputedValue_options,
      hidden: fieldWithComputedValue_hidden,
      required: fieldWithComputedValue_required,
      kind: fieldWithComputedValue_kind,
      error: fieldWithComputedValue_error
    };
    var tmp = {
      dropdownDirection: dropdownDirection,
      formId: form.id,
      product: form.product,
      field: fieldWithComputedValue,
      onChange: handleChange,
      scrollIntoViewOnError: scrollIntoViewOnError
    };
    if (optionSize$1 !== undefined) {
      tmp.optionSize = Caml_option.valFromOption(optionSize$1);
    }
    if (optionStyle !== undefined) {
      tmp.optionStyle = Caml_option.valFromOption(optionStyle);
    }
    if (truncateAt$1 !== undefined) {
      tmp.truncateAt = truncateAt$1;
    }
    if (tabIndex !== undefined) {
      tmp.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    return React.createElement(React.Fragment, {
      children: Curry._3(onRender, fieldWithComputedValue, handleChange, React.createElement(PDPForm$Field, tmp)),
      key: Curry._1(PDPFormTypes$Showside.FieldId.toString, rawField.id) + rawField.label
    });
  });
}
PDPForm$AllFields.displayName = "PDPForm.AllFields";
var AllFields = {
  make: PDPForm$AllFields
};
function PDPForm$SubmitButton(Props) {
  var children = Props.children;
  var label = Props.label;
  var disableWhenOutOfStockOpt = Props.disableWhenOutOfStock;
  var disabledLabel = Props.disabledLabel;
  var confirmation = Props.confirmation;
  var setConfirmation = Props.setConfirmation;
  var submitButtonType = Props.submitButtonType;
  var onSubmit = Props.onSubmit;
  var disableWhenOutOfStock = disableWhenOutOfStockOpt !== undefined ? disableWhenOutOfStockOpt : true;
  var match = React.useState(function () {
    return false;
  });
  var setBusy = match[1];
  var isBusy = match[0];
  var match$1 = React.useState(function () {});
  var confirmation$1 = Belt_Option.getWithDefault(confirmation, match$1[0]);
  var setConfirmation$1 = Belt_Option.getWithDefault(setConfirmation, match$1[1]);
  var match$2 = React.useContext(context);
  var form = match$2.form;
  var match$3 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var clearConfirmationTimeout = match$3.clearTimeout;
  var setConfirmationTimeout = match$3.setTimeout;
  React.useEffect(function () {
    Curry._1(clearConfirmationTimeout, undefined);
    setConfirmationTimeout(function (param) {
      Curry._1(setConfirmation$1, function (param) {});
      Curry._1(setBusy, function (param) {
        return false;
      });
    }, 3000);
  }, [confirmation$1, isBusy]);
  var variant = form.variant;
  var isCurrentVariantOutOfStock = variant !== undefined ? variant.availability === /* OutOfStock */0 && disableWhenOutOfStock : false;
  var noPendingFields = Belt_Array.every(form.fields, function (field) {
    var activeOptions = Belt_Array.keep(field.options, function (param) {
      return !param.disabled;
    });
    var match = field.initialValue;
    if (match !== undefined || activeOptions.length === 0) {
      return true;
    } else {
      return Belt_Array.some(form.orderOfSelection, function (f) {
        return Caml_obj.equal(f.id, field.id);
      });
    }
  });
  var disabled = isCurrentVariantOutOfStock && noPendingFields && willValidate(submitButtonType);
  var disabledLabel$1 = Belt_Option.keep(disabledLabel, function (str) {
    if (str.trim() !== "" && disabled) {
      return !isBusy;
    } else {
      return false;
    }
  });
  var confirmationLabel = Belt_Option.keep(confirmation$1, function (str) {
    if (str.trim() !== "") {
      return !isBusy;
    } else {
      return false;
    }
  });
  return React.createElement(Spread$Showside.make, {
    props: {
      onClick: function (param) {
        var submission = makeSubmission(willValidate(submitButtonType), form, submitButtonType, applyOrderOfSelection(form.orderOfSelection, form.fields));
        if (submission.TAG === /* AllGood */0) {
          var match = submission._0.submitButtonType;
          if (typeof match === "number") {
            if (match !== 0) {} else {
              Curry._1(setBusy, function (param) {
                return true;
              });
            }
          } else if (match.confirmation !== undefined) {
            Curry._1(setBusy, function (param) {
              return true;
            });
          }
        }
        Belt_Option.forEach(onSubmit, function (os) {
          Curry._1(os, submission);
        });
        Curry._1(form.onSubmit, submission).then(function (confirmation) {
          Curry._1(setBusy, function (param) {
            return false;
          });
          Curry._1(setConfirmation$1, function (param) {
            return confirmation;
          });
          return Promise.resolve(undefined);
        });
      },
      disabled: disabled && Belt_Option.isSome(disabledLabel$1) || isBusy,
      label: disabledLabel$1 !== undefined ? disabledLabel$1 : confirmationLabel !== undefined ? confirmationLabel : label
    },
    children: children
  });
}
PDPForm$SubmitButton.displayName = "PDPForm.SubmitButton";
var SubmitButton = {
  make: PDPForm$SubmitButton
};
function PDPForm$AddToCartButton$PendingVariantSelector(Props) {
  var show = Props.show;
  var product = Props.product;
  var pending = Props.pending;
  var submitButtonType = Props.submitButtonType;
  var onChange = Props.onChange;
  var match = React.useContext(context);
  var submittedCallback = match.submittedCallback;
  var form = match.form;
  var resetFormData = function (param) {
    Curry._1(onChange, []);
    Curry._1(form.reset, undefined);
  };
  React.useEffect(function () {
    if (show) {} else {
      resetFormData(undefined);
    }
  }, [show]);
  var currentFieldName = Belt_Array.get(pending, 0);
  var currentField = Belt_Option.mapWithDefault(currentFieldName, [], function (__x) {
    return Product$Showside.getOptionsByName(product, __x);
  });
  var currentFieldId = Belt_Option.map(Belt_Option.map(Belt_Array.get(currentField, 0), function (param) {
    return param.id;
  }), PDPFormTypes$Showside.FieldId.fromString);
  var currentFormField = Belt_Option.flatMap(currentFieldId, function (__x) {
    return getFieldById(form.fields, __x);
  });
  var label = Belt_Option.mapWithDefault(Belt_Option.map(Belt_Option.map(currentFormField, function (param) {
    return param.label;
  }), function (label) {
    return StringUtils$Showside.concatWithoutRepeat("Select", label).toUpperCase();
  }), null, function (label) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("opacity-50 flex-shrink-0 text-center text-base font-semibold pt-2")
    }, label);
  });
  var dataTestId = currentFormField !== undefined && currentFormField.name === "Size" ? "product-card-size-button" : undefined;
  var tmp = {
    dataTestId: "product-card-add-to-cart-prompt",
    children: React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col space-y-1 bg-main border border-main text-primary border-solid rounded-custom w-full")
    }, label, React.createElement("div", {
      className: CSS$Showside.prefix("inline-flex flex-wrap flex-grow justify-center")
    }, Belt_Array.keepMap(Belt_Array.mapWithIndex(currentField, function (index, option) {
      return Belt_Option.map(Belt_Array.get(Product$Showside.getVariantsByOptionNames(true, product, Belt_Array.concat(Belt_Array.keepMap(Belt_Array.map(Belt_Array.keep(form.fields, function (field) {
        return Curry._1(PDPFormTypes$Showside.FieldId.toString, field.id) !== option.id;
      }), fieldToProductOption), function (a) {
        return a;
      }), [{
        id: option.id,
        name: option.name,
        value: option.value
      }])), 0), function (variant) {
        var partial_arg = option.value;
        var tmp = {
          label: option.value,
          disabled: variant.availability === /* OutOfStock */0,
          selected: false,
          size: /* Sm */1,
          style: /* NoBorder */1,
          dataId: option.value,
          onClick: function (param) {
            if (currentFormField === undefined) {
              return;
            }
            var nextPending = Belt_Array.keepWithIndex(pending, function (param, i) {
              return i !== 0;
            });
            Curry._1(form.onChange, {
              id: currentFormField.id,
              name: currentFormField.name,
              label: currentFormField.label,
              value: partial_arg,
              initialValue: currentFormField.initialValue,
              options: currentFormField.options,
              hidden: currentFormField.hidden,
              required: currentFormField.required,
              kind: currentFormField.kind,
              error: currentFormField.error
            }).then(function (fields) {
              Curry._1(onChange, nextPending);
              if (nextPending.length !== 0) {
                return;
              } else {
                resetFormData(undefined);
                Curry._1(form.onSubmit, makeSubmission(undefined, form, submitButtonType, fields)).then(function (confirmation) {
                  Curry._1(submittedCallback, undefined);
                });
                return;
              }
            });
          },
          key: variant.id
        };
        if (dataTestId !== undefined) {
          tmp.dataTestId = Caml_option.valFromOption(dataTestId);
        }
        return React.createElement(PDPOptionButton$Showside.make, tmp);
      });
    }), function (a) {
      return a;
    })))
  };
  var tmp$1 = Belt_Option.map(currentFieldId, PDPFormTypes$Showside.FieldId.toString);
  if (tmp$1 !== undefined) {
    tmp.dataId = tmp$1;
  }
  return React.createElement(DataAttribute$Showside.make, tmp);
}
PDPForm$AddToCartButton$PendingVariantSelector.displayName = "PDPForm.AddToCartButton.PendingVariantSelector";
var PendingVariantSelector = {
  make: PDPForm$AddToCartButton$PendingVariantSelector
};
function PDPForm$AddToCartButton(Props) {
  var showOpt = Props.show;
  var product = Props.product;
  var variant = Props.variant;
  var category = Props.category;
  var label = Props.label;
  var disableWhenOutOfStock = Props.disableWhenOutOfStock;
  var disabledLabel = Props.disabledLabel;
  var confirmationLabel = Props.confirmationLabel;
  var children = Props.children;
  var onAddToCart = Props.onAddToCart;
  var show = showOpt !== undefined ? showOpt : true;
  var match = React.useState(function () {
    return [];
  });
  var setPendingSelections = match[1];
  var pendingSelections = match[0];
  var match$1 = React.useState(function () {});
  var setConfirmation = match$1[1];
  var submittedCallback = function (param) {
    Curry._1(setConfirmation, function (param) {
      return confirmationLabel;
    });
  };
  var handleFormSubmit = function (submission) {
    if (submission.TAG === /* AllGood */0) {
      var match = submission._0;
      Curry._1(setPendingSelections, function (param) {
        return [];
      });
      Curry._4(onAddToCart, match.product, match.variant, 1, category);
      return new Promise(function (resolve, reject) {
        setTimeout(function (param) {
          resolve(confirmationLabel);
        }, 1000);
      });
    }
    var errors = submission._0;
    Curry._1(setPendingSelections, function (param) {
      return Belt_Array.map(errors, function (param) {
        return param.fieldName;
      });
    });
    return Promise.resolve(undefined);
  };
  var handleChange = function (pending) {
    Curry._1(setPendingSelections, function (param) {
      return pending;
    });
  };
  var tmp;
  if (pendingSelections.length !== 0) {
    tmp = React.createElement(PDPForm$AddToCartButton$PendingVariantSelector, {
      show: show,
      product: product,
      variant: variant,
      pending: pendingSelections,
      submitButtonType: /* AddToCart */0,
      onChange: handleChange
    });
  } else {
    var tmp$1 = {
      children: children,
      label: label,
      disabledLabel: disabledLabel,
      confirmation: match$1[0],
      setConfirmation: setConfirmation,
      submitButtonType: /* AddToCart */0
    };
    if (disableWhenOutOfStock !== undefined) {
      tmp$1.disableWhenOutOfStock = disableWhenOutOfStock;
    }
    tmp = React.createElement(PDPForm$SubmitButton, tmp$1);
  }
  return React.createElement(PDPForm$Wrapper, {
    product: product,
    variant: variant,
    submittedCallback: submittedCallback,
    hideOutOfStock: false,
    onSubmit: handleFormSubmit,
    children: tmp
  });
}
PDPForm$AddToCartButton.displayName = "PDPForm.AddToCartButton";
var AddToCartButton = {
  PendingVariantSelector: PendingVariantSelector,
  make: PDPForm$AddToCartButton
};
function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8) {
  var tmp = {
    product: prim0,
    variant: prim1,
    hideOutOfStock: prim3,
    children: prim6
  };
  if (prim2 !== undefined) {
    tmp.submittedCallback = Caml_option.valFromOption(prim2);
  }
  if (prim4 !== undefined) {
    tmp.onChange = Caml_option.valFromOption(prim4);
  }
  if (prim5 !== undefined) {
    tmp.onSubmit = Caml_option.valFromOption(prim5);
  }
  if (prim7 !== undefined) {
    tmp.key = prim7;
  }
  return tmp;
}
var make = PDPForm$Wrapper;
export { _HIDDEN_OPTIONS, _REQUIRED_OPTIONS, _IMAGE_OPTIONS, _DROPDOWN_OPTIONS, _ALWAYS_SHOW_OPTIONS, getFieldById, getFieldValue, mergeFieldErrors, fieldToProductOption, isFieldEmpty, willValidate, getVariantByFields, validate, makeSubmission, noopPromise1, noopPromise2, noop1, emptyForm, dynamicallyDisableAndHideOptions, dynamicallyChooseOptimalValue, applyOrderOfSelection, makeFieldsFromProduct, Wrapper, QuantityPicker, Field, AllFields, SubmitButton, AddToCartButton, makeProps, make, use };
/* emptyForm Not a pure module */